module.exports = __webpack_public_path__ + "static/media/your_posts_black.6fa9c14d.svg";